import { FormattedMessage } from 'react-intl';
import React from 'react';
import { FULFILLMENTS_CANCELLED_VIEW_ID, FULFILLMENTS_VIEW_ID } from './view-id-constants';

export const FulfillmentsCancelled = {
  label: (
    <FormattedMessage defaultMessage='Cancelled' description='shipping page left nav item for in cancelled fulfillments' id='gcMSmH' />
  ),

  expandedDescription: (
    <FormattedMessage
      defaultMessage='Fulfillments / Cancelled'
      description='shipments page grid header, fulfillments.cancelled'
      id='zd1fJ1'
    />
  ),

  id: FULFILLMENTS_CANCELLED_VIEW_ID,
  navigationOverride: '/shipments/fulfillments/cancelled',
  parentId: FULFILLMENTS_VIEW_ID,
};
